<!-- Header -->
<app-header></app-header>

<!-- Site-Specific Navigation -->
<!-- <np-menu [location]="NavigationLocation.SiteSpecific"></np-menu> -->

<!-- Main Content -->
<main class="main">
    <router-outlet></router-outlet>
</main>

<app-loader></app-loader>

<app-msg-popup *ngIf="logoutWarningPopupShow">
  <div *ngIf="idleWarningContentShow">
    You are being inactive for 60 mins. application will logout in 15mins.
  </div>

  <div *ngIf="idleLogoutContentShow">
    Your session has expired! <a href="{{redirectURL}}">Click here to Logon.</a>
  </div>
</app-msg-popup>
<!-- Footer -->
<app-footer></app-footer>